export default __webpack_public_path__ + "static/media/up-logo.54d95c8c.svg";